import {
  Component,
  ElementRef,
  Input,
  OnInit,
} from '@angular/core';
import {GoogleAnalyticsService} from "../../services/google-analytics/google-analytics.service";
import {Router} from "@angular/router";
import {TypeUtils} from "../../utils/type-utils";

@Component({
    selector: 'db-score-info-tooltip-hover',
    templateUrl: 'score-info-tooltip-hover.component.html',
    styleUrls: ['score-info-tooltip-hover.component.scss'],
    standalone: false
})
export class ScoreInfoTooltipHoverComponent implements OnInit {

  @Input() websiteScore: any;
  @Input() websiteId: number;
  @Input() showLearnMore: boolean = false;
  @Input() demoUser: boolean;

  public scores = [
    {name: 'Desktop', value: null, loadTime: null},
    {name: 'Mobile', value: null, loadTime: null}
  ];
  public radiusScore: number = 4.5 * 3.14 * 25;

  constructor(
    private $element: ElementRef,
    private googleAnalyticsService: GoogleAnalyticsService,
    private _router: Router,
  ) {}

  ngOnInit() {
    this.calculateScore(this.websiteScore);
  }

  public redirectToInner(websiteId: number): void {
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: "MoveTo10Web Page visit",
      eventLabel: 'Learn more tooltip click',
      websiteId: websiteId
    };
    this.googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
    this._router.navigateByUrl(`/websites/${websiteId}/move-to-10web`);
  }

  private calculateScore(scoreData): void {
    this.scores[0].value = scoreData && scoreData.currentScore && !TypeUtils.isNull(scoreData.currentScore.desktopScore) ? scoreData.currentScore.desktopScore : null;
    this.scores[1].value = scoreData && scoreData.currentScore && !TypeUtils.isNull(scoreData.currentScore.mobileScore) ? scoreData.currentScore.mobileScore : null;
    this.scores[0].loadTime = scoreData && scoreData.currentScore && !TypeUtils.isNull(scoreData.currentScore.desktopTTI) ? scoreData.currentScore.desktopTTI : null;
    this.scores[1].loadTime = scoreData && scoreData.currentScore && !TypeUtils.isNull(scoreData.currentScore.mobileTTI) ? scoreData.currentScore.mobileTTI : null;
  }

}
